import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  tagCloudDropdown: muiSelectStyles.filterSelect,

  tagCloudMenuProps: muiSelectStyles.filterPaper,

  tagCloudDropdownItem: muiSelectStyles.filterMenuItem,
};
